import { render, staticRenderFns } from "./prelimAllocationEdit.vue?vue&type=template&id=29cbf27c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "prelimAllocationEdit.vue"
export default component.exports